import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const MaritalStatus = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <Donut
            title={'Estado Civil'}
            subtitles={chartData?.maritalStatus?.map(
                (item) => item.description
            )}
            chartData={chartData?.maritalStatus || []}
            colors={
                defaultColors.slice(0, chartData?.maritalStatus?.length) || []
            }
            height={400}
            className="aligned-container"
        />
    );
};
